<template>
  <div>
    <div class="row">
      <div id="pane-left" class="col-md-6 pane">

        <sale-search-products :processing_add_to_cart="processing_add_to_cart"></sale-search-products>

      </div>
      <div id="pane-right" class="col-md-6 pane">

        <div v-if="!cart" class="card border-0 shadow-sm mt-3 mb-3">
          <div class="card-body">
            <div class="text-center p-4 text-muted">
              <i class="fas fa-shopping-cart"></i> No items are in the cart
            </div>
          </div>
        </div>

        <sale-customer v-if="cart" :cart="cart"></sale-customer>

        <sale-cart v-if="cart" :cart="cart"></sale-cart>

        <sale-payment-methods v-if="cart" :cart="cart" :payment_method_groups="payment_method_groups"></sale-payment-methods>

        <p v-if="cart" class="text-muted"><i class="fas fa-info-circle"></i> <strong>Important:</strong> Save the order before charging the customer to temporarily reserve stocks.</p>

      </div>
    </div>

    <div v-if="cart" id="cart-footer">
      <div class="right">
        <div class="wrapper clearfix">
          <sale-cart-credit-notes :cart="cart"></sale-cart-credit-notes>
          <sale-cart-gift-vouchers :cart="cart"></sale-cart-gift-vouchers>
          <sale-cart-payment-methods :cart="cart"></sale-cart-payment-methods>
          <div class="float-left">
            <button type="button" :class="'btn btn-lg mr-3 ' + ((!cart.shipping_address.name || cart.due) ? 'btn-outline-success' : 'btn-success')" @click.prevent="saveOrder" :disabled="!cart.shipping_address.name || cart.due || processing_save_order">
              <i class="fas fa-circle-notch fa-spin" v-if="processing_save_order"></i>
              Save Order
            </button>
            <span class="text-muted d-none d-xl-inline"><i class="fas fa-info-circle"></i> Do not charge the customer yet.</span>
          </div>
          <h1 class="float-right"><span class="text-muted small font-weight-light">Due:</span> {{ cart.due | numberToRs }}</h1>
        </div>
      </div>
    </div>

    <adjustments></adjustments>

    <credit-notes></credit-notes>

    <gift-voucher-codes></gift-voucher-codes>
  </div>
</template>

<script>
import axios from 'axios'
import jQuery from 'jquery'
import SaleSearchProducts from './partials/SearchProducts'
import SaleCustomer from './partials/Customer'
import SaleCart from './partials/Cart'
import SalePaymentMethods from './partials/PaymentMethods'
import SaleCartCreditNotes from './partials/CartCreditNotes'
import SaleCartGiftVouchers from './partials/CartGiftVouchers'
import SaleCartPaymentMethods from './partials/CartPaymentMethods'
import Adjustments from './partials/Adjustments'
import CreditNotes from './partials/CreditNotes'
import GiftVoucherCodes from './partials/GiftVoucherCodes'

export default {
  name: 'Sale',
  data () {
    return {
      processing_add_to_cart: false,
      fetching_payment_methods: false,
      processing_save_order: false,

      payment_method_groups: null,

      cart_id: localStorage.getItem('cart-id') || null,
      channel_id: localStorage.getItem('channel-id') || process.env.DEFAULT_CHANNEL,
      pending_order_id: localStorage.getItem('pending-order-id') || null,
      cart: null,
      customer: null
    }
  },
  components: {
    SaleSearchProducts,
    SaleCustomer,
    SaleCart,
    SalePaymentMethods,
    SaleCartCreditNotes,
    SaleCartGiftVouchers,
    SaleCartPaymentMethods,
    Adjustments,
    CreditNotes,
    GiftVoucherCodes
  },
  mounted () {
    if (this.pending_order_id) {
      this.$toast.error('Cannot create a new sale since a pending order is available')
      this.$router.push({name: 'order.payment', params: {order_id: this.pending_order_id}})
      return false
    }

    this.setPaneHeights()

    if (this.cart_id) {
      this.fetchCart()
    }
  },
  methods: {
    async _createCart () {
      return axios.post('/cart', {
        source: 'point_of_sale',
        channel_id: this.channel_id
      }).then((response) => {
        this.cart_id = response.data.data.id
        localStorage.setItem('cart-id', this.cart_id)
        return this.cart_id
      }).catch(error => {
        throw Error(typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : '')
      })
    },
    async _addToCart (productId, variantId, variantMerchantId, quantity, barcode) {
      if (!this.cart_id) {
        await this._createCart()
      }

      return axios.post('/cart/' + this.cart_id + '/products', {
        product_id: productId,
        variant_id: variantId,
        variant_merchant_id: variantMerchantId,
        quantity: quantity,
        barcode: barcode,
        include_cart: true
      }).then((response) => {
        this.cart = response.data.data.cart
        this.highlightAddedProduct(response.data.data.product)
        return this.cart
      }).catch(error => {
        throw Error(typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : '')
      })
    },

    highlightAddedProduct (product) {
      setTimeout(() => {
        const element = jQuery('tr#cart-product-' + product.key)

        element[0].scrollIntoView()

        element.find('td')
          .css('transition', 'none')
          .css('background-color', 'yellow')

        setTimeout(() => {
          element.find('td')
            .css('transition', 'background-color 1s ease')
            .css('background-color', 'white')
        }, 200)
      })
    },

    focusPaymentMethods () {
      const element = jQuery('#card-payment-methods')

      element[0].scrollIntoView(true)
    },

    setPaneHeights () {
      let screenHeight = jQuery(window).height()
      let navHeight = jQuery('nav').outerHeight()
      let footerHeight = jQuery('#cart-footer').outerHeight()
      let availableHeight = screenHeight - navHeight

      jQuery('#pane-left').height(availableHeight)
      jQuery('#pane-right').height(availableHeight - footerHeight)
    },

    fetchCart () {
      axios.get('/cart/' + this.cart_id, {
        params: {
          source: 'point_of_sale',
          channel_id: this.channel_id
        }
      }).then((response) => {
        this.cart = response.data.data
        this.cart_id = this.cart.id

        if (localStorage.getItem('cart-id') !== this.cart_id) {
          localStorage.setItem('cart-id', this.cart_id)
        }

        setTimeout(() => {
          this.setPaneHeights()
        }, 1500)
      }).catch(error => {
        this.cart_id = null
        this.$toast.error('Failed to get the cart. ' + (typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : ''))
      })
    },

    async addToCart (productId, variantId, variantMerchantId, quantity, barcode) {
      this.processing_add_to_cart = true

      if (!this.cart_id) {
        await this._createCart()
      }

      this._addToCart(productId, variantId, variantMerchantId, quantity, barcode)
        .catch((error) => {
          this.$toast.error(error)
        }).finally(() => {
          this.processing_add_to_cart = false
        })
    },

    fetchPaymentMethods () {
      this.fetching_payment_methods = true
      this.payment_method_groups = null

      axios.get('/cart/' + this.cart.id + '/payment_methods', {
        params: {
          sources: ['website', 'point_of_sale']
        }
      }).then((response) => {
        this.payment_method_groups = response.data.data
        setTimeout(() => {
          this.focusPaymentMethods()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to fetch payment methods. ' + (typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : ''))
      }).finally(() => {
        this.fetching_payment_methods = false
      })
    },

    saveOrder () {
      this.processing_save_order = true

      axios.post('/orders', {
        cart_id: this.cart.id
      }).then((response) => {
        if (typeof response.data.status === 'undefined' || !response.data.status) {
          this.processing_save_order = false
          this.$toast.error('Failed to save the order.' + typeof response.data.message !== 'undefined' ? response.data.message : 'Exact error is undefined.')
          return false
        }

        localStorage.setItem('pending-order-id', response.data.data.order_id)

        this.$router.push('order/' + response.data.data.order_id + '/payment')
      }).catch(error => {
        this.processing_save_order = false
        this.$toast.error('Failed to save the order.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)

        if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.cart !== 'undefined') {
          this.cart = error.response.data.cart
        }
      })
    }
  }
}
</script>

<style scoped>
  #cart-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 50%;
  }
  #cart-footer .right {
    padding-right: 0;
  }
  #cart-footer .right .wrapper {
    background: #e9ecef;
    padding: 15px 20px;
    box-shadow: 0 -1rem 3rem rgba(0,0,0,.175);
  }

  /*@media (min-width: 768px) {
    .pane {
      position: fixed;
      top: 52px;
      height: calc(100vh - 52px);
    }
    #pane-left {
      left: 0;
    }
    #pane-right {
      right: 0;
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/sale/Sale.vue